<template lang="html">
  <div class="interaction">
    <div class="content" v-if='code >= 0'>
      <div v-for="a in messageList" :key="a.id" class="messageList" @click="goMessage(a.id)">
        <div class="header">
          <div class="userInfo">
            <div class="userImg">
              <img :src="a.avatar" alt="" class="userHeadPortrait">
              <img src="@/assets/image/icon/pv.png" alt="" class="userMark" v-if="a.mp_type == 1">
              <img src="@/assets/image/icon/tv.png" alt="" class="userMark" v-if="a.mp_type == 2">
            </div>
            <p class="userName">{{a.username}}</p>
          </div>
          <img src="@/assets/image/icon/top.png" alt="" class="topIcon" v-show="a.is_recommend">
        </div>
        <div v-if="a.images.length > 0" class="messageConter aFigure">
          <div v-html="srtText(a.message)"></div>
          <img :src="a.images[0]" alt="">
        </div>
        <div v-else class="messageConter">
          <div v-html="srtText(a.message)"></div>
        </div>
        <div class="timeModel">
          <p class="userTime">{{a.createdate}}</p>
          <div class="hotModel">
            <div class="hotModelChild"><img src="@/assets/image/icon/replyIcon2.png" alt=""><span>{{a.is_recommend}}</span></div>
            <div class="hotModelChild"><img src="@/assets/image/icon/startPraise.png" alt=""><span>{{a.like_number}}</span></div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="noInfo" v-else>
      <div>
        <img :src="`${pagebase}/static/img/elecom/circle.png`" alt="">
      </div>
      <p>暂无内容哦~</p>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http'
  
  export default {
    props: ['userId'],

    data() {
      return {
        code: '',
        messageList: [],
        pagebase: pagebase,
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.getMessageList();
      },

      getMessageList() {
        this.$http({
          url: '/eleom/messageList',
          method: 'get',
          params: {
            master_id: this.userId,
            page: 1,
            limit: 20,
            type: 2,
          }
        }).then(res => {
          this.code = res.code;
          if (res.code >= 0) {
            this.messageList = res.data;
          }
        })
      },
      
      srtText(data){
        let text = data.replace(/<.*?>/g, "");
        return text;
      },
      
      goMessage(mid){
        sessionStorage.setItem('cur', 8);
        this.$router.push({
          path: '/aMessage',
          query: {
            mid: mid,
          }
        })
      }
    },
  }
</script>

<style lang="css" scoped>
  .content {
    background-color: #F7F8F8;
  }

  .messageList {
    position: relative;
    background-color: #FFFFFF;
    padding: 1.5rem;
    margin-bottom: .8rem;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #3F454B;
    font-size: 12px;
  }

  .userInfo {
    display: flex;
    align-items: center;
  }

  .userImg {
    position: relative;
  }

  .userHeadPortrait {
    width: 3.4rem;
    height: 3.4rem;
    border-radius: 50%;
  }

  .userMark {
    position: absolute;
    left: 2.2rem;
    bottom: 0;
    width: 1.2rem;
    height: 1.2rem;
  }
  
  .userName{
    margin-left: .8rem;
  }
  
  .topIcon {
    width: 3.2rem;
    height: 1.6rem;
  }
  
  .messageConter{
    max-height: 16.8rem;
    overflow: hidden;
    font-size: 1.4rem;
    color: #1D2023;
    margin-top: .7rem;
  }
  
  .aFigure{
    display: flex;
    justify-content: space-between;
  }
  
  .aFigure div {
    width: 22.7rem;
  }
  
  .aFigure img{
    width: 10rem;
    height: 6.3rem;
    border-radius: .5rem;
    object-fit: cover;
  }
  
  .timeModel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.5rem;
  }
  
  .userTime{
    font-size: 1.2rem;
    color: #C0C4CC;
  }
  
  .hotModel {
    display: flex;
  }
  
  .hotModelChild {
    width: 5.6rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  
  .hotModelChild img {
    width: 2rem;
    height: 2rem;
    margin-top: .1rem;
  }
  
  .hotModelChild span{
    font-size: 1.2rem;
    color: #3F454B;
    margin-left: .25rem;
  }  
  
  .noInfo {
    height: 37.5rem;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  
  .noInfo img {
    width: 19.5rem;
    height: 19.5rem;
  }
  
  .noInfo p {
    font-size: 1.4rem;
    color: #9CA3A9;
  }
</style>
